/**This custom maps is only for incident module */

import React, { useEffect, useRef } from "react";
import {
  MapContainer,
  TileLayer,
  Marker,
  useMapEvents,
  Popup,
} from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "./CustomMapForEdit.css";

// Create custom blue marker icon to match Google Maps style
const blueIcon = new L.Icon({
  iconUrl: 'data:image/svg+xml;base64,PHN2ZyBiYXNlUHJvZmlsZT0iYmFzaWMiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDQ4IDQ4IiBmaWxsPSIjZjQ0MzM2Ij48cGF0aCBkPSJNMjQgNGMtNy43MyAwLTE0IDYuMjctMTQgMTQgMCAxMC41IDE0IDI2IDE0IDI2czE0LTE1LjUgMTQtMjZjMC03LjczLTYuMjctMTQtMTQtMTR6bTAgMTkuMWMtMi44MSAwLTUuMS0yLjI5LTUuMS01LjFzMi4yOS01LjEgNS4xLTUuMSA1LjEgMi4yOSA1LjEgNS4xLTIuMjkgNS4xLTUuMSA1LjF6Ii8+PC9zdmc+',
  iconSize: [40, 40],
  iconAnchor: [20, 40],
  popupAnchor: [0, -40]
});


const CustomMapForEdit = ({
  coordinates = [],
  chooseCoordinates,
  initialZoom = 13,
  zoom = 13,
  autoZoom = true,
  closeMapModal,
  popUpShow = false,
  bankEdit
}) => {
  const mapRef = useRef();

  const handleClick = (e) => {
    const { lat, lng } = e.latlng;
    chooseCoordinates?.(lng, lat); // Pass lng, lat to parent
    if (closeMapModal) {
      closeMapModal();
    }
  };

  const MapClickHandler = () => {
    useMapEvents({
      click: handleClick,
    });
    return null;
  };

  // Default center for India
  const defaultCenter = [20.5937, 78.9629];
  
  // Get center from the first coordinate if available
  const center = coordinates?.length > 0 
    ? [coordinates[0].x, coordinates[0].y] 
    : defaultCenter;

  // Set map view when coordinates change
  useEffect(() => {
    if (mapRef.current && coordinates?.length > 0 && autoZoom) {
      mapRef.current.setView([coordinates[0].x, coordinates[0].y], zoom);
    }
  }, [coordinates, zoom, autoZoom]);

  return (
    <MapContainer
      center={center}
      attributionControl={false}
      zoom={zoom || initialZoom}
      scrollWheelZoom={true}
      style={{ height: bankEdit ? "100%" : "98%", width: "100%", position: "sticky" }}
      ref={mapRef}
      whenCreated={(mapInstance) => {
        mapRef.current = mapInstance;
        
        // Set view to initial coordinates if available
        if (coordinates?.length > 0 && autoZoom) {
          mapInstance.setView([coordinates[0].x, coordinates[0].y], zoom || initialZoom);
        }
      }}
    >
      <TileLayer 
        url="https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}"
        subdomains={['mt0', 'mt1', 'mt2', 'mt3']}
        // attribution='&copy; Google Maps'
      />

      {coordinates?.length > 0 && coordinates.map((coord, idx) => (
        <Marker 
          key={`marker-${idx}`} 
          position={[coord.x, coord.y]}
          icon={blueIcon}
        >
          {popUpShow && (
            <Popup>
              Latitude: {coord.x}<br />
              Longitude: {coord.y}
            </Popup>
          )}
        </Marker>
      ))}

      <MapClickHandler />
    </MapContainer>
  );
};

export default CustomMapForEdit;